import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { Subject } from 'rxjs';

@Component({
  standalone: false,
  selector: 'finxone-platform-workflow-card-selection-dialog',
  templateUrl: './card-selection-dialog.component.html',
  styleUrls: ['./card-selection-dialog.component.scss'],
})
export class WorkflowCardSelectionDialogComponent {
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  @Input() title: string;

  @Output() contentUpdateEvent = new EventEmitter<string>();

  modalCls = 'card-selection-dialog';

  modalStyle = {
    height: '400px',
    maxHeight: '250px',
    maxWidth: '35vw',
  };

  @Input() cardList = ['MoneyFin Card 1', 'MoneyFin Card 2'];
  @Input() selectionCard = 'MoneyFin Card 1';

  private ngxSmartModalService = inject(NgxSmartModalService);

  constructor() {}

  closeAlert() {
    this.ngxSmartModalService.get('cardSelectionDialog').close();
  }
}
